import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom/client';
import { Nationalities } from "./api/services/next.js";
import { GetResources } from "./api/services/shell.js";
import LanguageContext from "./language.js";
import ApplicationContext from "./context.js";
import { SemanticToastContainer } from "react-semantic-toasts-2";
import { Dimmer, Loader } from "semantic-ui-react";

// HS-70186: every React root on a page (MainMenu, PageHeader, the page itself) mounts
// its own AppWrapper - share one GetNationalities request between them instead of one
// per root. A failed request is dropped so the next mount retries.
let nationalitiesRequest = null;
const getNationalitiesOnce = () => {
    if (!nationalitiesRequest) {
        nationalitiesRequest = Nationalities.GetNationalities().catch((error) => {
            nationalitiesRequest = null;
            throw error;
        });
    }
    return nationalitiesRequest;
};

export const AppWrapper = ({ children }) => {
    const [state, setState] = useState({
        loader: false,
        user: null,
        counter: 0,
        nationalities: [],
    });

    const [language, setLanguage] = useState();

    useEffect(() => {
        (async () => {
            try {
                const nationalities = await getNationalitiesOnce();
                setState((prevState) => ({ ...prevState, nationalities }));
                let language;
                if (window.optima && window.optima.resourceManager) {
                    language = window.optima.resourceManager;
                } else if (window.resourceManager) {
                    language = window.resourceManager;
                } else {
                    language = await GetResources();
                }
                setLanguage(language);
            } catch (error) {
                console.log(error)
            }
        })();
    }, []);

    useEffect(() => {
        // Add a toast container if not already present
        const toastContainer = document.getElementById("toast-container");
        if (!toastContainer) {
            const newToastContainer = document.createElement("div");
            newToastContainer.id = "toast-container";
            document.body.appendChild(newToastContainer);
            ReactDOM.createRoot(newToastContainer).render(
                <SemanticToastContainer
                    position="top-right"
                    transition="slide left"
                    animation="fade"
                    time={5000}
                    maxToasts={5}
                />
            );
        }
    }, []);

    if (!language) {
        return  <Dimmer active>
            <Loader>Loading</Loader>
        </Dimmer>
    }
    return (
        <LanguageContext.Provider value={language}>
            <ApplicationContext.Provider value={{ state, setState }}>
                {children}
                <div id="portal-container" />
                {/*Enables injection of other components from other places in the system without overriding
            the current used tree of the DOM by using:
            OptimaUI.render(COMPONENT-NAME, "portal-container", {props}*/}
            </ApplicationContext.Provider>
        </LanguageContext.Provider>
    );
};